import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_AccountSubsidies_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_AccountSubsidies_Modules_ApiEnum {
    'results' = 'results',
}

export enum Config_AccountSubsidies_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_AccountSubsidies_PageMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_AccountSubsidies_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_AccountSubsidies_ApiInterface
    extends ConfigDataInterface<
        Config_AccountSubsidies_Modules_ApiEnum,
        Config_AccountSubsidies_ActionsMenu_ApiEnum,
        Config_AccountSubsidies_ActionsOther_ApiEnum,
        Config_AccountSubsidies_PageMenu_ApiEnum,
        Config_AccountSubsidies_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
